export const ABOUT = "ABOUT";
export const BLOG = "BLOG";
export const CAREER = "CAREER";
export const CONTACT = "CONTACT";
export const OFFER = "OFFER";
export const OFFER_3D_DESIGN = "OFFER_3D_DESIGN";
export const OFFER_APPS = "OFFER_APPS";
export const OFFER_BRANDING = "OFFER_BRANDING";
export const OFFER_COPYWRITING = "OFFER_COPYWRITING";
export const OFFER_ECOMMERCE = "OFFER_ECOMMERCE";
export const OFFER_GOOGLEADS = "OFFER_GOOGLEADS";
export const OFFER_ILLUSTRATION = "OFFER_ILLUSTRATION";
export const OFFER_MEDIA = "OFFER_MEDIA";
export const OFFER_SEO = "OFFER_SEO";
export const OFFER_SOCIALMEDIA = "OFFER_SOCIALMEDIA";
export const OFFER_WEBDESIGN = "OFFER_WEBDESIGN";
export const OFFER_WEBPAGES = "OFFER_WEBPAGES";
export const REALISATIONS = "REALISATIONS";
export const REALISATIONS_DESIGN = "REALISATIONS_DESIGN";
export const REALISATIONS_MARKETING = "REALISATIONS_MARKETING";
export const REALISATIONS_MEDIA = "REALISATIONS_MEDIA";
export const REALISATIONS_WEBDEV = "REALISATIONS_WEBDEV";
export const SOLUTIONS = "SOLUTIONS";
export const PPWB = "PPWB";
export const PARP = "PARP";

export default {
  ABOUT,
  BLOG,
  CAREER,
  CONTACT,
  OFFER,
  OFFER_3D_DESIGN,
  OFFER_APPS,
  OFFER_BRANDING,
  OFFER_COPYWRITING,
  OFFER_ECOMMERCE,
  OFFER_GOOGLEADS,
  OFFER_ILLUSTRATION,
  OFFER_MEDIA,
  OFFER_SEO,
  OFFER_SOCIALMEDIA,
  OFFER_WEBDESIGN,
  OFFER_WEBPAGES,
  REALISATIONS,
  REALISATIONS_DESIGN,
  REALISATIONS_MARKETING,
  REALISATIONS_MEDIA,
  REALISATIONS_WEBDEV,
  SOLUTIONS,
  PPWB,
  PARP
};
